import firebase from 'firebase';
import { db } from '@/firebase'
export default {
  resetSistema({ commit }) {
    commit('caracteristicas/setCaracteristicasArray', [], { root: true });
    commit('categorias/setCategoriasArray', [], { root: true });
    commit('clientes/setClientes', [], { root: true });
    commit('cocinas/setCocinas', [], { root: true });
    commit('descuentos/setDescuentosArray', [], { root: true });
    commit('impuestos/setImpuestosArray', [], { root: true });
    commit('internos/setPedidos', [], { root: true });
    commit('internos/setCategorias', [], { root: true });
    commit('internos/setProductos', [], { root: true });
    commit('negocios/negociosArray', [], { root: true });
    commit('negocios/setPedidosArray', [], { root: true });
    commit('negocios/setClientesNegocio', [], { root: true });
    commit('negocios/setComputers', [], { root: true });
    commit('negocios/setImpresoras', [], { root: true });
    commit('neo/setProductosNeoOpciones', [], { root: true });
    commit('neo/setProductosNeo', [], { root: true });
    commit('neo/resetDatosNeo', [], { root: true });
    commit('pedidos/setPedidosArray', [], { root: true });
    commit('productos/resetProductos', [], { root: true });
    commit('restaurantes/resetRestaurantes', [], { root: true });
    commit('restaurantes/setPedidosArray', [], { root: true });
    commit('tickets/setTicketsArray', [], { root: true });
    commit('totems/setTotemsArray', [], { root: true });
    commit('users/setUsers', [], { root: true });
    commit('users/setUsersAuth', [], { root: true });
    location.reload();
  },
  saveOcultarRestauranteDashboard({ }, rest) {
    return db.collection('configuracion').doc('dashboard').set({
      ocultarRestaurantes: firebase.firestore.FieldValue.arrayUnion(rest)
    }, { merge: true })
  },
  saveMostrarrRestauranteDashboard({ }, rest) {
    return db.collection('configuracion').doc('dashboard').set({
      ocultarRestaurantes: firebase.firestore.FieldValue.arrayRemove(rest)
    }, { merge: true })
  },
  getConfiguracionDashboard({ commit }) {
    return db.collection('configuracion').doc('dashboard').get()
      .then(r => {
        if (r.exists) {
          commit('setDashboardConfig', r.data())
        }
      })
  },
  //toma los datos dee negociois y restaurantes y monta el listado según el tipo de 
  //facturación que tengan
  getClientesFacturar({ rootState, commit }) {
    var res = []
    var promesas = []
    rootState.negocios.negociosArray.forEach(n => {
      promesas.push(
        db.collection('negocios').doc(n.id).collection('secreto').doc('facturacion')
          .get().then(r => {
            if (r.exists) {
              let d = r.data();
              if (d.modoFacturacion == "negocio") {
                res.push(
                  {
                    modo: 'negocio',
                    ...d,
                    ...n
                  }
                )
              } else {
                res.push(
                  {
                    modo: 'negocio',
                    ...d,
                    ...n
                  })
                return db.collection('restaurantes').where('negocio', '==', n.id).get()
                  .then(r => {
                    if (r.size > 0) {
                      var promesasRest = [];
                      r.forEach(rest => {
                        let restData = {
                          ...rest.data(),
                          id: rest.id
                        }
                        promesasRest.push(db.collection('restaurantes').doc(restData.id).collection('secreto').doc('facturacion')
                          .get()
                          .then(r => {
                            if (r.exists) {
                              res.push({
                                modo: 'restaurante',
                                nombreNegocio: n.nombre,
                                ...r.data(),
                                ...restData,
                              })
                            }
                          })

                        )
                      })
                    }
                    return Promise.all(promesasRest)
                  })
              }
            }
          })
      )
    })
    return Promise.all(promesas).then(() => {
      commit('setClientesFacturar', res)
    })
      .catch(e => console.log(e))

  },
  getStatusCuentas({ commit }) {
    return db.collection('status').onSnapshot(r => {
      commit('setStatusCuentas', r.docs.map(c => {
        return {
          ...c.data(),
          id: c.id
        }
      }))
    })
  }
}